import { Card, CardContent } from '../ui/card.tsx';
import { Skeleton } from '../ui/skeleton.tsx';

// Skeleton de lista padrão (skeleton no carregamento, nunca spinner), com o FORMATO de uma
// linha de lista: o tile do ícone/avatar, duas linhas de texto e o valor à direita, a mesma
// anatomia de `ListRow`, `IconListCard` e da linha de venda. As larguras variam por linha
// pra não parecer uma grade mecânica. `bare` remove o `Card` para quando o skeleton já vive
// dentro de um painel.
const WIDTHS = [
  ['w-2/5', 'w-3/5'],
  ['w-1/2', 'w-2/5'],
  ['w-1/3', 'w-1/2'],
] as const;

export function ListSkeleton({ rows = 5, bare = false }: { rows?: number; bare?: boolean }) {
  const lines = Array.from({ length: rows }, (_, index) => {
    const [title, sub] = WIDTHS[index % WIDTHS.length] ?? WIDTHS[0];
    return (
      // biome-ignore lint/suspicious/noArrayIndexKey: linhas de placeholder não têm identidade
      <div key={index} className="flex items-center gap-3">
        <Skeleton className="size-8 shrink-0 rounded-lg" />
        <div className="grid min-w-0 flex-1 gap-1.5">
          <Skeleton className={`h-3 ${title}`} />
          <Skeleton className={`h-2.5 ${sub}`} />
        </div>
        <Skeleton className="h-3 w-12 shrink-0" />
      </div>
    );
  });

  if (bare) {
    return <div className="grid gap-3 p-4">{lines}</div>;
  }

  return (
    <Card>
      <CardContent className="grid gap-3 py-4">{lines}</CardContent>
    </Card>
  );
}
